import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from '../src/redux/store'
import { Provider } from 'react-redux';
import { setAuthToken } from './utils/validations/setAuthToken';
import { setCurrentUser } from './redux/actions/authAction';
import jwtDecode from 'jwt-decode';
import { applyUiSettings, loadUiSettings } from './utils/uiSettings';
import { installLocalizedDialogs } from './utils/notificationText';
import { installLocalizedModalContent } from './utils/dialogText';


const root = ReactDOM.createRoot(document.getElementById('root'));
applyUiSettings(loadUiSettings());
installLocalizedDialogs();
installLocalizedModalContent();
setAuthToken(localStorage.token)
if(localStorage.token){
  setAuthToken(localStorage.token)
  store.dispatch(setCurrentUser(jwtDecode(localStorage.token)))
}
root.render(
    <Provider store={store}>
      <App />
    </Provider>
);

reportWebVitals();
